/**
* FAQ Accordion JS
* -----------------------------------------------------------------------------
*
* All the JS for the FAQ Accordion component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'faq-accordion',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );

      $( '.faq-accordion__item-status, .faq-accordion__item-title' ).click( function() {
        if ( $( this ).closest( '.faq-accordion__item' ).hasClass( 'is-open' ) ) {
          $( this ).closest( '.faq-accordion__item' ).find( '.faq-accordion__item-answer' ).slideUp();
          $( this ).closest( '.faq-accordion__item' ).removeClass( 'is-open' );
          $( this ).closest( '.faq-accordion__item .faq-accordion-trigger' ).attr( 'aria-expanded', false );
        } else {
          $( '.faq-accordion__item.is-open .faq-accordion__item-answer' ).slideUp();
          $( '.faq-accordion__item' ).removeClass( 'is-open' ).not( $( this ).closest( '.faq-accordion__item' ) ).find( '.faq-accordion-trigger' ).attr( 'aria-expanded', false );
          $( this ).closest( '.faq-accordion__item' ).find( '.faq-accordion__item-answer' ).slideDown();
          $( this ).closest( '.faq-accordion__item' ).find( '.faq-accordion-trigger' ).attr( 'aria-expanded', true );
          $( this ).closest( '.faq-accordion__item' ).addClass( 'is-open' );
        }
      } );

      // Bind keyboard behaviors on the main accordion container
      $( document ).on( 'keydown', '.faq-accordion', function( event ) {
        const accordion = this;
        const triggers = Array.prototype.slice.call( accordion.querySelectorAll( '.faq-accordion-trigger' ) );
        const target = event.target;
        const key = event.which.toString();

        const isExpanded = target.getAttribute( 'aria-expanded' ) == 'true';

        // 33 = Page Up, 34 = Page Down
        const ctrlModifier = ( event.ctrlKey && key.match( /33|34/ ) );

        // Is this coming from an accordion header?
        if ( target.classList.contains( 'faq-accordion-trigger' ) ) {
          // Up/ Down arrow and Control + Page Up/ Page Down keyboard operations
          // 38 = Up, 40 = Down
          if ( key.match( /38|40/ ) || ctrlModifier ) {
            const index = triggers.indexOf( target );
            const direction = ( key.match( /34|40/ ) ) ? 1 : -1;
            const length = triggers.length;
            const newIndex = ( index + length + direction ) % length;

            triggers[newIndex].focus();

            event.preventDefault();
          } else if ( key.match( /35|36/ ) ) {
            // 35 = End, 36 = Home keyboard operations
            switch ( key ) {
              // Go to first accordion
              case '36':
                triggers[0].focus();
                break;
                // Go to last accordion
              case '35':
                triggers[triggers.length - 1].focus();
                break;
            }
            event.preventDefault();
          }
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'faq-accordion', COMPONENT );
} )( app );
